var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", { ref: "validation" }, [
    _c(
      "div",
      { staticClass: "container-listagem" },
      [
        _c(
          "el-row",
          [
            _c(
              "el-col",
              [
                _c("Pesquisa", {
                  attrs: {
                    placeHolder:
                      "Informe o Cartório ou Município ou nº do Ofício",
                    cardStyle: {
                      margin: "0px 0px 10px 0px",
                      "border-radius": "12px"
                    }
                  },
                  on: {
                    search: _vm.handlePesquisa,
                    resetSearch: _vm.resetPesquisa
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "el-card",
          {
            staticClass: "default-card",
            attrs: {
              shadow: "hover",
              "body-style": {
                height: "100%",
                display: "flex",
                "flex-direction": "column"
              }
            }
          },
          [
            _vm.podeGerarOficio
              ? _c(
                  "div",
                  { staticClass: "container" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "left-align",
                        attrs: { type: "primary", name: "oficio" },
                        on: { click: _vm.goToEmissaoOficio }
                      },
                      [
                        _c("span", { staticClass: "center" }, [
                          _c("i", { staticClass: "fa fa-file-alt" }),
                          _c("b", [_vm._v("  Gerar Ofício")])
                        ])
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c("app-divider-refresh-button", {
              attrs: {
                label: _vm.label,
                hasButton: true,
                content: "Atualizar ofícios"
              },
              on: { click: _vm.resetPesquisa }
            }),
            _c(
              "div",
              { staticClass: "container-table" },
              [
                _c("table-generica", {
                  attrs: {
                    colunas: _vm.colunas,
                    botoesAcao: _vm.botoesAcao,
                    sortChanged: _vm.sortChanged,
                    dados: _vm.oficios
                  }
                }),
                _c("app-paginacao", {
                  attrs: { total: _vm.total, pagina: _vm.pagina },
                  on: { changePage: _vm.changePage }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("app-buttons-cadastro", {
          attrs: {
            isPrimeiroPasso: true,
            isUltimoPasso: true,
            showButtonSalvar: false
          },
          on: { cancelar: _vm.cancelar, finalizar: _vm.finalizar }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d161d66a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d161d66a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/cpat/Oficios.vue
// module id = null
// module chunks = 